import { Component, inject, signal } from '@angular/core';
import { AudioService } from '../../core/services/audio';
import { ScreenNavigationService } from '../../core/services/screen-navigation';
import { ModeCard } from '../../shared/components/mode-card/mode-card';

@Component({
  selector: 'app-home',
  imports: [ModeCard],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class HomePage {
  private readonly screenNavigation = inject(ScreenNavigationService);
  private readonly audio = inject(AudioService);

  protected onSoloClick(): void {
    this.audio.playPageTransition();
    this.screenNavigation.goToTheme();
  }

  protected onDailyClick(): void {
    this.audio.playPageTransition();
    this.screenNavigation.goToDailyTheme();
  }
}
